import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaRegTrashAlt } from 'react-icons/fa';
import { ObjModal } from '../../../../contexts';
import AddToGroup from '../../../Modals/AddToGroup';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';


const Lists = ( { aid, uid, removeItem } ) => {
    const { objType, obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );

    useEffect( () => {
        setExpanded( obj.lists.length > 0 );
    }, [ obj.lists ] );

    const trash = async ( gaid, gid ) => {
        let removed = [];

        if ( objType === 'contact' ) {
            removed = await removeItem( { aid: gaid, uid: uid, items: [ obj.details.cid ], gid: gid } );
        } else if ( objType === 'loan' ) {
            removed = await removeItem( { aid: gaid, uid: uid, items: [ obj.details.lid ], gid: gid } );
        }

        if ( removed.length ) {
            // toast.success( 'The item has been removed from the list', { theme: 'dark' } );
        } else {
            console.log( removed );
        }
    };

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'group':
                if ( objType === 'contact' ) {
                    setModal( <AddToGroup close={closeModal} itemType='contacts' items={ [ obj.details.cid ] } aid={obj.details.aid} /> ); 
                } else if ( objType === 'loan' ) {
                    setModal( <AddToGroup close={closeModal} itemType='loans' items={ [ obj.details.lid ] } aid={obj.details.aid} /> ); 
                }
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>List Memberships ({obj.lists.length})</Typography></Col>
                        <Col xs='auto' className='p-0'><Button variant='outline-primary' size='sm' onClick={ () => handleModal( 'group' ) }>+ Add</Button></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush'>
                    { obj.lists.map( ( l, idx ) => (
                        <ListGroup.Item key={idx}>
                            <Row>
                                <Col><Link to={`/list/${l.gid}`}>{l.label}</Link></Col>
                                <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( l.aid, l.gid ) } /></Col>
                            </Row>
                        </ListGroup.Item>
                    ) ) }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email
} );

const mapDispatch = ( dispatch ) => ( {
    removeItem: dispatch.lists.removeItem
} );

export default connect( mapProps, mapDispatch )( Lists );